export const CONTACT_FORM_REQUEST = 'CONTACT_FORM_REQUEST';
export const CONTACT_US_FORM_REQUEST = 'CONTACT_US_FORM_REQUEST';
export const FORM_REQUESTING = 'FORM_REQUESTING';
export const RESET_FORM_ISFETCHING = 'RESET_FORM_ISFETCHING';
export const SUBSCRIBE_FORM_REQUEST = 'SUBSCRIBE_FORM_REQUEST';
export const FEEDBACK_FORM_REQUEST = 'FEEDBACK_FORM_REQUEST';

export const GET_FORM_REQUEST = 'GET_FORM_REQUEST';
export const GET_FORM_SUCCESS = 'GET_FORM_SUCCESS';
export const SUBMIT_RESPONSE_REQUEST = 'SUBMIT_RESPONSE_REQUEST';
